// extracted by css-extract-rspack-plugin
export default {"dynamicTable":"rqNReDN6aV0HHWjR","red":"iBtdyLkeh5ALVIiH","green":"LVYquU2hKmgF8Jc9","orange":"q98uXcUY_mYfkyHT","noData":"YPyyBRslLUw0jHxD","grayText":"D7u8sNTuAkXv8vU8"};